import { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useStatsigClient } from '@statsig/react-bindings';
import { GATES } from '@constants';
import { DownloadIcon, IconButton, toast } from '@utilities';
import { createDoc, generateFile } from './utilities/helpers';

const DownloadDOCXButton = ({ survey }) => {
  const [isDownloading, setIsDownloading] = useState(false);
  const user = useSelector((state) => state?.user?.data);
  const { client } = useStatsigClient();
  const canDownloadDOCX = client.checkGate(GATES.DOWNLOAD_SURVEY_AS_DOCX);

  if (!canDownloadDOCX) return null;

  const handleDownload = async () => {
    setIsDownloading(true);
    try {
      const doc = await createDoc(survey, user?.email);

      const defaultTitle = `survey_${survey.id}`;
      const title = survey.title || defaultTitle;
      const sanitizedTitle =
        title
          .replace(/[/\\:*?"<>|]/g, '_')
          .replace(/\.+$/g, '')
          .trim() || defaultTitle;

      const fileName = `${sanitizedTitle}.docx`;
      await generateFile(doc, fileName);
    } catch (error) {
      console.error('DOCX generation error:', error);
      toast(`Failed to generate Word document${error?.message ? `: ${error.message}` : ''}`, {
        status: 'error',
      });
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <IconButton
      isDisabled={isDownloading}
      onClick={handleDownload}
      tooltip={isDownloading ? 'Generating Word document...' : 'Download Survey as Word Document'}
    >
      <DownloadIcon />
    </IconButton>
  );
};

DownloadDOCXButton.propTypes = {
  survey: PropTypes.object.isRequired,
};

export default DownloadDOCXButton;
